<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

import BaseSettingsHeader from '../../components/BaseSettingsHeader.vue';
import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';

// ACESSO-01 (L9a): o topo das duas abas de Papéis, Papéis e Grupos. A aba é a rota: trocar de aba é trocar de rota, e
// o botão da direita é de quem usa (Novo papel, Novo grupo).
const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const abas = computed(() => [
  { rota: 'papeis_lista', label: t('PAPEIS.ABAS.PAPEIS') },
  { rota: 'papeis_grupos', label: t('PAPEIS.ABAS.GRUPOS') },
]);
const abaAtiva = computed(() =>
  abas.value.findIndex(aba => aba.rota === route.name)
);

const trocarDeAba = aba => {
  if (aba.rota === route.name) return;
  router.push({
    name: aba.rota,
    params: { accountId: route.params.accountId },
  });
};
</script>

<template>
  <BaseSettingsHeader
    :title="t('PAPEIS.TITULO')"
    :description="t('PAPEIS.DESCRICAO')"
  >
    <template #tabs>
      <TabBar
        as-tabs
        :tabs="abas"
        :initial-active-tab="abaAtiva"
        @tab-changed="trocarDeAba"
      />
    </template>
    <template #actions>
      <slot name="acoes" />
    </template>
  </BaseSettingsHeader>
</template>
